import * as React from 'react';
import { useAccountTwrrCCurrencyCode, useAccountTwrrPTAccTwrrPSumOut } from '../../hooks';
import { ActorApiNumberDisplayCurrency } from '../../../../../../components/display/number/currency';

export const AccountsTwrrTAccTwrrSumOut = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountTwrrPTAccTwrrPSumOut();
  const {
    data: currencyData,
    isLoading: currencyIsLoading,
    error: currencyError,
  } = useAccountTwrrCCurrencyCode();
  return (
    <ActorApiNumberDisplayCurrency
      data={data}
      isLoading={isLoading}
      error={error}
      currencyData={currencyData}
      currencyIsLoading={currencyIsLoading}
      currencyError={currencyError}
    />
  );
};
